import ContactInfoItem from './ContactInfoItem';

export default ContactInfoItem;
